<template>
	<div id="body">
		<div class="title">
			<i class="el-icon-warning-outline"></i> 暂无权限
		</div>
		
		<div>
			<img src="../assets/error.jpg" >
		</div>
		<div style="font-size: 20px; text-align: center; margin-top: 20px;">
			<div style="width: 60%; color: red; margin: 0 auto;">{{ text }}</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: "",
	  data() {
		return {
			text:'',
		};
	  },
	  methods: {
		  
	  },
	  created() {
	  	this.text = this.$route.query.text
	  }
	};
</script>

<style scoped="scoped">
	
</style>
